import React from 'react';

import { Avatar, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

type Props = {
  avatar?: string;
  name?: string;
  email?: string;
};

const ProposalAcceptence = ({ avatar, email, name }: Props) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title"
        fontColor="secondary"
        strong
      >
        PROPOSAL ACCEPTENCE
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <div className="value">
            <Typography className="title">Technician : </Typography>
            <Avatar size="md" src={avatar || ''} />
            <Typography className="value">{name || ''}</Typography>
          </div>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Email : </Typography>
          <Typography className="value">{email || ''}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default ProposalAcceptence;
